import { render, staticRenderFns } from "./I18nEntityFormModal.vue?vue&type=template&id=294809c0"
import script from "./I18nEntityFormModal.vue?vue&type=script&lang=js"
export * from "./I18nEntityFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports